import { render, staticRenderFns } from "./space-log-report.vue?vue&type=template&id=527ff60d&scoped=true"
import script from "./space-log-report.vue?vue&type=script&lang=js"
export * from "./space-log-report.vue?vue&type=script&lang=js"
import style0 from "./space-log-report.vue?vue&type=style&index=0&id=527ff60d&prod&lang=less&scoped=true"
import style1 from "./space-log-report.vue?vue&type=style&index=1&id=527ff60d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527ff60d",
  null
  
)

export default component.exports